import memoizeOne from 'memoize-one';
import type {
	StateDependencyItem,
	SelectedDependency,
} from '@atlassian/jira-aais-dependency-lines-overlay/src/common/ui/types.tsx';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { DependencyItem } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/ui/chart-timeline-overlay/dependency-lines/types.tsx';

export const transformDependencies = memoizeOne(
	(dependencies: StateDependencyItem[]): DependencyItem[] =>
		dependencies.map(({ from, to, itemHeight }: StateDependencyItem) => ({
			itemHeight,
			from,
			to,
		})),
);

export const getSelectedDependency = memoizeOne(
	(issueId: IssueId, dependees: IssueId[]): SelectedDependency => ({
		fromId: issueId,
		toId: dependees[0],
	}),
);
